module.exports = __webpack_public_path__ + "img/firma-biotec.00814cf1.png";